import { atom, selector } from "recoil"
import {
  checkoutPageTypeValues,
  SubdomainPageType,
  TabButtonPosition
} from "../../../constants/enums"
import MOLocation from "../../../util/MOLocation"
import { isPrivateRoomAtom } from "../privateRoom"
import { Room, RoomIdsSetterAction, RoomBranding } from "./types"

export const defaultRoom = {
  name: "",
  roomHash: "",
  roomSessionId: "",
  branding: {}
}

const roomAtom = atom({
  key: "room",
  default: null
})

const brandingAtom = atom({
  key: "brandingAtom",
  default: null
})

export const brandingSelector = selector<RoomBranding | null>({
  key: "brandingSelector",
  get: ({ get }) => {
    return get(brandingAtom)
  },
  set: ({ set, get }, newProps) => {
    set(brandingAtom, { ...get(brandingAtom), ...newProps })
  }
})

export const roomSelector = selector<Room | null>({
  key: "roomSelector",
  get: ({ get }) => {
    return get(roomAtom)
  },
  set: ({ set }, action) => {
    const { name, attributes } = action as RoomIdsSetterAction

    if (name === "RESET") {
      set(roomAtom, defaultRoom)
    } else {
      set(roomAtom, roomObj => ({ ...roomObj, ...attributes }))
    }
  }
})

interface RoomCallbackSelectorProps {
  handleReturnData?: () => Promise<Room | null>
}

export const roomCallbackSelector = selector<RoomCallbackSelectorProps>({
  key: "roomCallbackSelector",
  get: ({ getCallback }) => {
    const handleReturnData = getCallback(({ snapshot }) => async () => {
      const data = await snapshot.getPromise(roomAtom)

      return data
    })
    return { handleReturnData }
  }
})

export const showInteractivityRequiredVisualSelector = selector<Room | null>({
  key: "showInteractivityRequiredVisualSelector",
  get: ({ get }) => {
    return get(roomAtom)?.showInteractivityRequiredVisual
  },
  set: ({ set }, action) => {}
})

export const productCheckoutPageSelector = selector<boolean>({
  key: "checkoutPageTypeSelector",
  get: ({ get }) => {
    return (
      // eslint-disable-next-line eqeqeq
      get(roomAtom).checkoutPageType ==
      checkoutPageTypeValues.productCheckoutPage
    )
  }
})

// Return true if shows grid view is supported else false
export const isShowsGridViewSupportedSelector = selector<boolean>({
  key: "isShowsGridViewSupportedSelector",
  get: ({ get }) => {
    // hide the show tab in private room
    return (
      get(roomAtom).subdomainPageType === SubdomainPageType.GRID &&
      !get(isPrivateRoomAtom)
    )
  }
})


// Return true if tab is to show at buttom for mobile user
export const showTabsAtBottomOnMobileSelector = selector<boolean>({
  key: "showTabsAtBottomOnMobileSelector",
  get: ({ get }) => {
    // true if admin has set tab to Bottom or useBottomTab url param is enabled
    const isUrlParamSetForBottomTab = MOLocation.getQueryParams().useBottomTab === true
    return  get(roomAtom).tabButtonPositionMobile === TabButtonPosition.BOTTOM || isUrlParamSetForBottomTab
  }
})
